import React from 'react';
import c from 'classnames';
import { MAIN_CONTENT_ID } from '../../config/constants';

import './style.scss';


const Main: React.FC<Omit<React.ComponentProps<'main'>, 'id'>> = ({ className, ...props }) => {
  const ref = React.useRef<HTMLElement>(null);

  const classes = c('Main', className);

  return (
    <main ref={ref} id={MAIN_CONTENT_ID} className={classes} {...props} />
  );
};

export default Main;
